import { render, staticRenderFns } from "./GTextareaForm.vue?vue&type=template&id=593d7b18&"
import script from "./GTextareaForm.vue?vue&type=script&lang=ts&"
export * from "./GTextareaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports